import React, { Component } from 'react';
import { bindActionCreators, compose } from 'redux';
import { connect } from 'react-redux';
import { first, get, isEmpty } from 'lodash';

import RemoveFromPurchaseDefault from '../components/remove-from-purchase/remove-for.default';
import RemoveFromPurchaseResolve from '../components/remove-from-purchase/remove-for.resolve';
import { COVER_SHARES_OPTION, REDISTRIBUTE_SHARES_OPTION } from '../components/resolve-payment-issues/index';
import Purchase from '../lib/purchase';
import {
  getCurrentUserMembership,
  getCurrentPurchase,
} from '../selectors/purchase-selector';
import {
  removeMembership,
  removeMemberships,
  fetchPurchase,
  hideRemoveModal,
  showResolveIssuesModal,
  showMakeChangesModal,
  showCommitModal,
  showAlert,

  ALERT_DASHBOARD_MEMBERS_REMOVED,
} from '../actions/index';

import withDashboardProjectionFetcher from '../../components/hoc/with-dashboard-projection-fetcher';

class RemoveFromPurchase extends Component {
  state = {
    isSubmitting: false
  };

  onSubmit = () => {
    const { memberships, authentication, actions } = this.props;
    const { removeMembership, hideRemoveModal, showAlert } = actions;
    const membership = first(memberships);

    this.setState({ isSubmitting: true }, () => {
      removeMembership(membership.id, authentication)
        .then(() => {
          const shouldRefreshDashboard = membership.status === 'committed';

          hideRemoveModal();
          showAlert(ALERT_DASHBOARD_MEMBERS_REMOVED);

          if (shouldRefreshDashboard) this.refreshDashboard();

          this.setState({ isSubmitting: false })
        })
        .catch(() => this.setState({ isSubmitting: false }));
    });
  }

  refreshDashboard = () => {
    const { purchaseId, actions, fetchDashboardProjection } = this.props;
    actions.fetchPurchase(purchaseId);
    fetchDashboardProjection();
  }

  onResolveBack = () => {
    this.props.actions.hideRemoveModal();
    this.props.actions.showResolveIssuesModal();
  }

  onResolveContinue = () => {
    const {
      purchaseId,
      memberships,
      authentication,
      resolveOptions,
      fetchDashboardProjection,
      actions
    } = this.props;
    const {
      removeMemberships,
      fetchPurchase,
      hideRemoveModal,
      showAlert,
      showCommitModal,
      showMakeChangesModal
    } = actions;
    const { optionSelected } = resolveOptions;

    this.setState({ isSubmitting: true }, () => {
      removeMemberships(memberships, authentication)
        .then(() => {
          this.setState({ isSubmitting: false });

          fetchPurchase(purchaseId);
          fetchDashboardProjection();
          hideRemoveModal();
          showAlert(ALERT_DASHBOARD_MEMBERS_REMOVED);

          if (optionSelected === COVER_SHARES_OPTION) {
            showCommitModal(this.props.resolveOptions);
          }

          if (optionSelected === REDISTRIBUTE_SHARES_OPTION && this.canRedistributeShares()) {
            showMakeChangesModal(this.props.resolveOptions);
          }
        })
        .catch(() => this.setState({ isSubmitting: false }));
    });

  }

  canRedistributeShares() {
    const { minSlots, userMembership } = this.props;
    if (Purchase.isSpecifiedPerPerson(this.props.splitType)) return false;
    return minSlots <= userMembership.claimedSlots;
  }

  render() {
    const { isSubmitting } = this.state;

    if (!isEmpty(this.props.resolveOptions)) {
      return (
        <RemoveFromPurchaseResolve
          isSubmitting={isSubmitting}
          onBack={this.onResolveBack}
          onContinue={this.onResolveContinue}
          memberships={this.props.memberships}
        />
      );
    }

    return (
      <RemoveFromPurchaseDefault
        isSubmitting={isSubmitting}
        onSubmit={this.onSubmit}
        onCancel={this.props.actions.hideRemoveModal}
        memberships={this.props.memberships}
      />
    );
  }
}

const mapStateToProps = (state) => {
  const { ui, session } = state;
  const userMembership = getCurrentUserMembership(state);
  const purchase = getCurrentPurchase(state);

  return {
    userMembership,
    purchaseId: purchase.id,
    minSlots: purchase.group.minSlots,
    splitType: purchase.group.splitType,
    memberships: get(ui.modals, 'remove.memberships', []),
    resolveOptions: get(ui.modals, 'remove.resolveOptions', {}),
    authentication: session.authentication,
  };
};

const mapDispatchToProps = (dispatch) => {
  const containerActions = {
    removeMembership,
    removeMemberships,
    fetchPurchase,
    hideRemoveModal,
    showResolveIssuesModal,
    showMakeChangesModal,
    showCommitModal,
    showAlert
  };

  return {
    actions: bindActionCreators(containerActions, dispatch),
  };
};

export default compose(
  withDashboardProjectionFetcher,
  connect(mapStateToProps, mapDispatchToProps)
)(RemoveFromPurchase);



// WEBPACK FOOTER //
// ./src/desktop/containers/remove-from-purchase.container.js